import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  donationAmountPerNGO,
  donationAmountPerProject,
  donationCountPerNGO,
  donationPerNGO,
  donationPerProject,
  makeDonation,
  makeDonationProject,
} from "appState/api/donation/donation";

export const makeTKDonation = createAsyncThunk(
  "donation/makeTKDonation",
  makeDonation
);
export const makeProjectDonation = createAsyncThunk(
  "donation/makeProjectDonation",
  makeDonationProject
);

export const getDonationPerNgo = createAsyncThunk(
  "donation/getDonationPerNgo",
  donationPerNGO
);

export const getDonationCountPerNGO = createAsyncThunk(
  "donation/getDonationCountPerNGO",
  donationCountPerNGO
);
export const getDonationPerProject = createAsyncThunk(
  "donation/getDonationPerProject",
  donationPerProject
);

export const totalDonationAmountPerNgo = createAsyncThunk(
  "donation/totalDonationAmountPerNgo",
  donationAmountPerNGO
);

export const totalDonationAmountPerProject = createAsyncThunk(
  "donation/totalDonationAmountPerProject",
  donationAmountPerProject
);

const initialState = {
  isLoading: false,
  donations: [],
  projectDonations: [],
  projectDonationsCount: null,
  totalDonationAmount: null,
  totalDonationCount: null,
  totalDonationAmountPerProject: 0,
};

export const donationSlice = createSlice({
  name: "donation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(makeTKDonation.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(makeTKDonation.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(makeTKDonation.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(makeProjectDonation.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(makeProjectDonation.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(makeProjectDonation.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getDonationPerNgo.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getDonationPerNgo.fulfilled, (state, action) => {
      state.isLoading = false;
      state.donations = action.payload?.data?.response;
    });
    builder.addCase(getDonationPerNgo.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getDonationCountPerNGO.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getDonationCountPerNGO.fulfilled, (state, action) => {
      state.isLoading = false;
      state.totalDonationCount = action.payload?.data?.response;
    });
    builder.addCase(getDonationCountPerNGO.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getDonationPerProject.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getDonationPerProject.fulfilled, (state, action) => {
      state.isLoading = false;
      state.projectDonations = action.payload?.data?.response;
      state.projectDonationsCount = action.payload?.data?.response?.length;
    });
    builder.addCase(getDonationPerProject.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(totalDonationAmountPerNgo.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(totalDonationAmountPerNgo.fulfilled, (state, action) => {
      state.isLoading = false;
      state.totalDonationAmount = action.payload?.data?.response;
    });
    builder.addCase(totalDonationAmountPerNgo.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(totalDonationAmountPerProject.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      totalDonationAmountPerProject.fulfilled,
      (state, action) => {
        state.isLoading = false;
        state.totalDonationAmountPerProject = action.payload?.data?.response;
      }
    );
    builder.addCase(totalDonationAmountPerProject.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default donationSlice.reducer;
